// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "version": "1.12.1",
    "timestamp": "2026-10-09T13:24:52.606Z"
};
/* tslint:enable */
